<template>
  <b-modal
    id="eventPageLoginModal"
    centered
    size="md"
    modal-class="loginModal"
    header-class="loginModal__header pb-1 border-0"
    body-class="loginModal__body pb-3 pb-md-4"
    footer-class="loginModal__footer text-center d-block pt-2 pt-md-4 pb-4 pb-md-3 border-0"
    @hidden="$router.push({
      name: 'event-eid',
      params: $route.params
    })">
    <div class="loginModal__title text-center st_color_main_light pb-3">
      報名前請先登入喔！
    </div>
    <div class="loginModal__content st_color_gray_darker">
      登入後即可進行報名流程～
    </div>

    <template slot="modal-footer">
      <b-container
        class="p-0 mb-md-3"
        fluid>
        <a
          class="loginModal__footer__login text-white pt-3 pb-3 d-block mx-auto"
          :href="user.loginUrl">
          <img src="/images/line-icon.png">
          登入 LINE 帳號
        </a>
      </b-container>
      <b-container
        class="p-0 m-0"
        fluid>
        <b-button
          class="st_sub_s d-none d-md-block mx-auto"
          @click="$root.$emit('bv::hide::modal', 'eventPageLoginModal')">
          取消
        </b-button>
      </b-container>
    </template>
  </b-modal>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    computed: {
      ...mapGetters(['user']),
    },
    mounted () {
      this.$root.$emit('bv::show::modal', 'eventPageLoginModal')
    },
  }
</script>

<style lang="scss">
  .loginModal {
    .modal-content {
      border-color: $st_color_gray_light;
    }

    &__header {
      @include media-breakpoint-up(md) {
        display: none;
      }

      .close {
        font-size: 19px;
        font-weight: bolder;
      }
    }

    &__title {
      font-size: 18px;
      font-weight: $st_font-weight-medium;

      @include media-breakpoint-up(md) {
        font-size: 21px;
      }
    }

    &__body {
      padding-top: 0;

      @include media-breakpoint-up(md) {
        padding-top: 30px;
        padding-left: 38px;
        padding-right: 38px;
      }
    }

    &__content {
      text-align: center;

      @include media-breakpoint-up(md) {
        text-align: left;
      }
    }

    &__footer {
      font-weight: $st_font-weight-medium;

      &__login {
        background-color: #00c43e;
        border-radius: 2px;
        font-size: 17px;
        max-width: 287px;

        img {
          max-width: 26px;
        }
      }
    }
  }
</style>
